import { gql } from '../../../artifacts/gql';

export const resolvePhoneConflict = gql(`
  mutation webResolvePhoneConflictMutation($phone: String!) {
    collectResolvePhoneConflict(phone: $phone) {
      successful
      messages {
        message
        code
      }
    }
  }
`);
